// AUTO-GENERATED from KFCStKitts/Models/MenuCategory.swift — do not hand-edit.
// Restaurant types, food-related gate, and per-type menu categories, in
// rawValue (display string) form so they match Firestore data 1:1.

export const RESTAURANT_TYPES = [
  "Fast Food",
  "Bar & Grill",
  "Pizza",
  "KFC",
  "BBQ Grill",
  "Seafood Restaurant",
  "Cafe",
  "Beauty Supply",
  "Retail Store",
  "Farmer",
  "Supermarket",
  "Fish/Meat Market",
  "Asian",
  "Indian",
  "Bakery",
  "Juice Stand",
  "Craft & Souvenirs",
  "Liquor Store & Smoke Shop",
  "Roti/Patty",
  "Perfume Store",
  "Jewelry Store",
  "Electronics Store",
  "Home Goods",
  "Water Supply",
  "Vegetarian",
  "Snack Boxes",
  "Car Parts",
  "Pharmacy",
  "Latin",
  "Mexican",
  "Sushi",
  "Steak House",
  "Local Restaurant"
];

const FOOD_RELATED = new Set([
  "Fast Food",
  "Bar & Grill",
  "Pizza",
  "KFC",
  "BBQ Grill",
  "Seafood Restaurant",
  "Cafe",
  "Bakery",
  "Asian",
  "Indian",
  "Roti/Patty",
  "Juice Stand",
  "Vegetarian",
  "Snack Boxes",
  "Latin",
  "Mexican",
  "Sushi",
  "Steak House",
  "Local Restaurant"
]);

export const isFoodRelated = (restaurantType) => FOOD_RELATED.has(restaurantType);

export const ALLERGEN_TYPES = [
  'Milk', 'Eggs', 'Peanuts', 'Tree Nuts', 'Fish', 'Shellfish', 'Soy', 'Wheat', 'Sesame',
];

export const MENU_PERIODS = ['Breakfast', 'Lunch', 'Dinner', 'Late Night'];

const CATEGORIES_BY_TYPE = {
  "fastFood": [
    "Meals",
    "Burgers",
    "Chicken",
    "Fish",
    "Seafood",
    "Sides",
    "Drinks",
    "Desserts",
    "Breakfast",
    "Fries",
    "Nuggets",
    "Wraps",
    "Salads",
    "Ice Cream",
    "Milkshakes",
    "Platters",
    "Soups",
    "Vegetarian",
    "Chicken Burger",
    "Beef Burger",
    "Pork Burger",
    "Fish Burger",
    "Veggie Burger",
    "Fried Chicken",
    "Curry Chicken",
    "Oxtail"
  ],
  "barAndGrill": [
    "Appetizers",
    "Main Course",
    "Grill Specials",
    "Seafood",
    "Ribs",
    "Lobster",
    "Grilled Fish",
    "Steaks",
    "Burgers",
    "Chicken",
    "Sides",
    "Drinks",
    "Desserts",
    "Cocktails"
  ],
  "pizza": [
    "Personal Pizza",
    "Small Pizza",
    "Medium Pizza",
    "Large Pizza",
    "Extra Large Pizza",
    "Stuffed Crust",
    "Garlic Knots",
    "Pizza Toppings",
    "Pizza Sides",
    "Pizzas",
    "Sides",
    "Drinks",
    "Burgers",
    "Chicken",
    "Fish",
    "Desserts"
  ],
  "asian": [
    "Rice Dishes",
    "Noodles",
    "Asian",
    "Fried Rice",
    "Soups",
    "Stir Fry",
    "Appetizers",
    "Drinks",
    "Salads",
    "Starters",
    "Chicken & Beef",
    "Seafood Meal",
    "Seafood",
    "Grilled Fish",
    "Steaks",
    "Lobster",
    "Vegetarian",
    "Sushi & Specialty Rolls",
    "Bento & Sushi Platters",
    "Cocktails",
    "Gluten-Free",
    "Sauces"
  ],
  "indian": [
    "Popular Items",
    "Burgers",
    "Shawarmas",
    "Shawarma Fries",
    "Salads",
    "Rice Meals",
    "Appetizers",
    "Pasta",
    "Pizza In A Pita",
    "Desserts",
    "Drinks",
    "Fish",
    "Seafood",
    "Steaks",
    " Indian Curry",
    "Biryani",
    "Naan",
    "Indian Roti",
    "Tandoori",
    "Tikka",
    "Samosa",
    "Pakoras",
    "Dal",
    "Paneer",
    "Vindaloo",
    "Korma",
    "Masala",
    "Sides",
    "Chutney",
    "Raita",
    "Lassi",
    "Gulab Jamun",
    "Kheer",
    "Curry",
    "Roti"
  ],
  "bbqGrill": [
    "Street Food",
    "Grilled Items",
    "Fried Chicken",
    "Wedges",
    "Fries",
    "Fried Fish",
    "Festival",
    "Jerk Chicken",
    "Jerk Pork",
    "Jerk Ribs",
    "Mixed",
    "Grilled Fish",
    "Grilled Lobster",
    "Garlic Bread",
    "Bakes"
  ],
  "seafood": [
    "Seafood",
    "Appetizers",
    "Main Course",
    "Grilled Items",
    "Grilled Fish",
    "Lobster",
    "Broil",
    "Steaks",
    "Fish & Chips",
    "Crab",
    "Shrimp",
    "Calamari",
    "Scallops",
    "Mussels",
    "Clams",
    "Oysters",
    "Seafood Platter",
    "Raw Bar",
    "Fried Seafood",
    "Seafood Stew",
    "Seafood Pasta",
    "Seafood Salad",
    "Sides",
    "Drinks",
    "Desserts",
    "Cocktails"
  ],
  "beauty": [
    "Beauty",
    "Hair Care",
    "Skin Care",
    "Nails",
    "Makeup",
    "Wigs",
    "Weaves",
    "Braids",
    "Beauty Accessories",
    "Hair Extensions",
    "Lace Products",
    "Edge Control",
    "Hair Gel",
    "Mousse",
    "Hair Spray",
    "Hair Color",
    "Relaxers",
    "Shampoos",
    "Conditioners",
    "Hair Masks",
    "Hair Oil",
    "Hair Products",
    "Lace Wigs",
    "Closures",
    "Frontals",
    "Wig Caps",
    "Wig Accessories",
    "Lace Glue",
    "Lace Remover",
    "Wig Maintenance",
    "Nail Polish",
    "Acrylics",
    "Gel Polish",
    "Nail Tips",
    "Nail Tools",
    "Nail Art",
    "Foundation",
    "Concealer",
    "Powder",
    "Lipstick",
    "Lip Gloss",
    "Eyeshadow",
    "Makeup Brushes",
    "Makeup Tools",
    "Eyelashes",
    "Lash Glue",
    "Eyebrow Products",
    "Cleansers",
    "Moisturizers",
    "Serums",
    "Toners",
    "Face Masks",
    "Body Care",
    "Perfume",
    "Body Sprays",
    "Barber Supplies",
    "Beard Care",
    "Shaving Products",
    "Hair Tools",
    "Flat Irons",
    "Curling Irons",
    "Blow Dryers",
    "Clippers",
    "Trimmers",
    "FashionJewelry",
    "Handbags",
    "Fashion Accessories",
    "Salon Supplies",
    "Disinfectants",
    "Salon Equipment"
  ],
  "store": [
    "Clothing",
    "Underwear",
    "Shoes",
    "Sandals",
    "Accessories",
    "Sports & Outdoors",
    "Toys",
    "Books"
  ],
  "farmer": [
    "Farmer",
    "Herbs",
    "Spices",
    "Banana",
    "Mango",
    "Apple",
    "Grape",
    "Strawberry",
    "Local Harvest",
    "Potatoes",
    "Lettuce",
    "Cabbages",
    "Yam",
    "Pepper",
    "Thyme",
    "Pineapple",
    "Watermelon",
    "Sugar Cane"
  ],
  "supermarket": [
    "Supermarket",
    "Dairy",
    "Bread",
    "Meat",
    "Produce",
    "Household",
    "Beverages",
    "Frozen",
    "Canned",
    "Snacks",
    "Condiments",
    "Cleaning",
    "Pet Food",
    "Baby Products",
    "Health",
    "Personal Care",
    "Frozen Fish",
    "Frozen Meat",
    "Oats",
    "Cornmeal",
    "Rice",
    "Flour",
    "Sugar",
    "Salt",
    "Spices",
    "Beans",
    "Lentils",
    "Grains",
    "Cooking Oil",
    "Vinegar",
    "Cereals",
    "Laundry Detergent",
    "Fabric Softener",
    "Dishwashing Liquid",
    "Detergent"
  ],
  "cafe": [
    "Coffee",
    "Pastries",
    "Cakes",
    "Cookies",
    "Muffins",
    "Donuts",
    "Pies",
    "Tarts",
    "Croissants",
    "Bagels",
    "Patties",
    "Sandwiches",
    "Salads",
    "Beverages",
    "Breakfast",
    "Eggs",
    "Pancakes",
    "Waffles",
    "Toast",
    "Bacon",
    "Sausage",
    "Omelets",
    "French Toast",
    "Smoothies",
    "Juice",
    "Soups"
  ],
  "fishAndMeat": [
    "Meat",
    "Fish"
  ],
  "kfc": [
    "Chicken Buckets",
    "Chicken Pieces",
    "Chicken Tenders",
    "Wings",
    "KFC Sandwiches",
    "KFC Bowls",
    "KFC Specials",
    "Sides",
    "Drinks",
    "Desserts"
  ],
  "bakery": [
    "Bakery",
    "Bread",
    "Cakes",
    "Pastries",
    "Cookies",
    "Muffins",
    "Donuts",
    "Pies",
    "Tarts",
    "Croissants",
    "Bagels",
    "Sandwiches",
    "Coffee",
    "Beverages",
    "Patties"
  ],
  "juiceStand": [
    "Coconut Water",
    "Lemonade",
    "Cane Juice",
    "Mango Juice",
    "Soursop Juice",
    "Special Mix",
    "Fruit Smoothies",
    "Protein Smoothies",
    "Drinks",
    "Beverages",
    "Juice",
    "Smoothies"
  ],
  "craft": [
    "Local Crafts",
    "Souvenirs",
    "Handmade Goods",
    "Local Art",
    "Pottery",
    "Woodwork",
    "Textiles",
    "Beads",
    "Shirts",
    "Perfumes"
  ],
  "liquorStoreSmokeShop": [
    "Spirits",
    "Wine",
    "Beer",
    "Tobacco",
    "Vapes",
    "Rolling Papers",
    "Glassware",
    "Mixers",
    "Grinders",
    "Scales",
    "Pipes",
    "Bongs",
    "Vaporizers",
    "Lighters",
    "Ash Trays",
    "Smoking Accessories",
    "Shirts",
    "Whiskey",
    "Rum",
    "Vodka",
    "Gin",
    "Tequila",
    "Brandy",
    "Liqueur",
    "Champagne",
    "Cordials",
    "Cocktail Mixers",
    "Bar Tools",
    "Ice",
    "Garnishes",
    "Snacks",
    "Beverages"
  ],
  "rotiShop": [
    "Roti",
    "Doubles",
    "Curry",
    "Chutney",
    "Buss Up Shut",
    "Dhal Puri",
    "Paratha",
    "Aloo Pie",
    "Samosas",
    "Beef Patty",
    "Chicken Patty",
    "Veggie Patty",
    "Cheese Patty",
    "Special Patty",
    "Patty",
    "Sides",
    "Drinks"
  ],
  "perfumeStore": [
    "Men's Cologne",
    "Women's Perfume",
    "Unisex Fragrance",
    "Body Spray",
    "Deodorant",
    "Aftershave",
    "Gift Sets",
    "Travel Size",
    "Designer Fragrance",
    "Body Oils",
    "Incense",
    "Scented Candles"
  ],
  "jewelryStore": [
    "Rings",
    "Necklaces",
    "Bracelets",
    "Earrings",
    "Watches",
    "Chains",
    "Pendants",
    "Engagement Rings",
    "Wedding Bands",
    "Gold Jewelry",
    "Silver Jewelry",
    "Diamond Jewelry",
    "Costume Jewelry",
    "Custom Designs",
    "Jewelry Repair"
  ],
  "electronicsStore": [
    "Phones",
    "Computers",
    "Tablets",
    "Laptops",
    "TVs",
    "Audio",
    "Cameras",
    "Gaming",
    "Smart Home",
    "Networking",
    "Printers",
    "Monitors",
    "Phone Cases",
    "Chargers",
    "Charging Cables",
    "Power Banks",
    "Screen Protectors",
    "Headphones",
    "Earbuds",
    "Smartwatches",
    "Fitness Trackers",
    "Microphones",
    "Webcams",
    "Bluetooth Speakers",
    "Party Speakers",
    "Gaming Accessories",
    "Cables & Adapters",
    "Memory Cards",
    "USB Drives",
    "Batteries",
    "Streaming Devices",
    "Home Automation",
    "Tablet Accessories",
    "Laptop Accessories",
    "Appliances",
    "Kitchen",
    "Tools",
    "Hardware",
    "Lighting",
    "Storage",
    "iPhone Screens",
    "Android Screens",
    "Tablet Screens",
    "Amplifiers",
    "Mid-Range Amplifiers",
    "Monoblock Amplifiers",
    "Subwoofers",
    "Mid-Range Speakers",
    "Tweeters",
    "Tweeter Amplifiers",
    "Car Radios",
    "Crossovers",
    "Window Tint",
    "Jumper Packs",
    "Portable Compressors",
    "Car Jacks",
    "Car Batteries",
    "Car Chargers",
    "Dash Cams",
    "GPS Navigation",
    "Car Speakers",
    "Car Audio Installation Kits"
  ],
  "homeGoods": [
    "Appliances",
    "Kitchen",
    "Furniture",
    "Bedding",
    "Bathroom",
    "Tools",
    "Hardware",
    "Lighting",
    "Storage",
    "Decor",
    "Screws",
    "Fasteners",
    "Bolts",
    "Nuts",
    "Washers",
    "Nail",
    "Anchors",
    "Hinges",
    "Latches",
    "Handles",
    "Knobs",
    "Locks",
    "Keys",
    "Rope",
    "Chain",
    "Wire",
    "Cable",
    "Tape",
    "Adhesives",
    "Sealants",
    "Pin",
    "House Paint",
    "Primer",
    "House Paint Brushes",
    "House Paint Rollers",
    "Paint Trays",
    "Drop Cloths",
    "Paint Remover",
    "Paint Thinners",
    "Wall Putty",
    "Spackle",
    "Tape Measure",
    "Hammer",
    "Shovel",
    "Wicks",
    "Drill Sets",
    "Jack Hammers",
    "Screwdrivers",
    "Pliers",
    "Wrenches",
    "Saws",
    "Levels",
    "Ladders",
    "Toolboxes",
    "Gloves",
    "Safety Glasses",
    "Safety Vests",
    "Work Boots",
    "Hard Hats",
    "Ear Protection",
    "Dust Masks",
    "Respirators"
  ],
  "waterSupply": [
    "Bottled Water",
    "Litre Bottle",
    "Spring Water",
    "Distilled Water",
    "Mineral Water",
    "Flavored Water",
    "Sparkling Water",
    "Water Coolers",
    "Water Dispensers",
    "Water Delivery",
    "Water Cups",
    "Ice"
  ],
  "vegetarian": [
    "Vegetarian",
    "Vegi Pizza",
    "Vegi Roti",
    "Vegi Soup",
    "Vegi Curry",
    "Vegi Burger",
    "Vegi Sandwich",
    "Vegi Wrap",
    "Vegi Pasta",
    "Vegi Salad",
    "Vegan",
    "Vegan Pizza",
    "Vegan Burger",
    "Vegan Desserts",
    "Tofu",
    "Tempeh",
    "Seitan",
    "Legumes",
    "Grains",
    "Plant-Based",
    "Gluten-Free",
    "Sides",
    "Drinks",
    "Desserts"
  ],
  "snackBoxes": [
    "Breakfast",
    "Waffles",
    "Pancakes",
    "French Toast",
    "Bagels",
    "Sandwiches",
    "Quesadillas",
    "Breakfast Combos",
    "Stuffed Waffles",
    "Waffle Combos",
    "Breakfast Bowls",
    "Saltfish Specials",
    "Brunch Boxes",
    "Event Packages",
    "Party Platters",
    "Snack Box",
    "Snack Box Sandwich",
    "Snack Box Wings",
    "Bakes",
    "Combo Box",
    "Breakfast Box",
    "Lunch Box",
    "Party Box",
    "Sides",
    "Drinks",
    "Desserts",
    "Proteins"
  ],
  "carParts": [
    "Engine Parts",
    "Brakes",
    "Suspension",
    "Exhaust",
    "Tires",
    "Wheels",
    "Motorcycle Tires",
    "Dirt Bike Tires",
    "Scooter Tires",
    "Truck Tires",
    "Decals",
    "Oil Filters",
    "Air Filters",
    "Spark Plugs",
    "Belts",
    "Hoses",
    "Radiators",
    "Alternators",
    "Car Starters",
    "Fuel Pumps",
    "Transmission",
    "Clutch",
    "Headlights",
    "Taillights",
    "Turn Signals",
    "Brake Lights",
    "Mirrors",
    "Wipers",
    "Car Battery",
    "Motor Oil",
    "Transmission Fluid",
    "Brake Fluid",
    "Coolant",
    "Power Steering Fluid",
    "Gear Oil",
    "Octane Boost",
    "Fuel Treatment",
    "Car Paint",
    "Car Primer",
    "Thinner",
    "Sandpaper",
    "Body Filler",
    "Spray Paint",
    "Clear Coat",
    "Rubbing Compound",
    "Polishing Compound",
    "Masking Tape",
    "Paint Brushes",
    "Paint Rollers",
    "Paint Sprayers",
    "Amplifiers",
    "Mid-Range Amplifiers",
    "Monoblock Amplifiers",
    "Subwoofers",
    "Mid-Range Speakers",
    "Tweeters",
    "Tweeter Amplifiers",
    "Car Radios",
    "Crossovers",
    "Window Tint",
    "Jumper Packs",
    "Portable Compressors",
    "Car Jacks",
    "Car Chargers",
    "Dash Cams",
    "GPS Navigation",
    "Car Speakers",
    "Car Audio Installation Kits",
    "Brake Pads",
    "Brake Rotors",
    "Shocks",
    "Struts",
    "Wheel Bearings",
    "Fuel Injectors",
    "Ignition Coils",
    "OBD Scanners",
    "Seat Covers",
    "Floor Mats",
    "Car Alarms",
    "GPS Trackers",
    "Reverse Cameras",
    "Tire Repair Kits",
    "Motorcycle Batteries",
    "Brake Calipers",
    "Brake Lines",
    "Timing Belt",
    "Piston Rings",
    "Valve Cover Gasket",
    "Control Arms",
    "Sway Bar Links",
    "Spark Plug Wires",
    "Fuse Box",
    "Relay",
    "Fuel Filter",
    "Fuel Pressure Regulator",
    "Fan Clutch",
    "Transmission Mount",
    "Shift Solenoid",
    "Cabin Air Filter",
    "Spare Tire",
    "Tire Pressure Sensor",
    "Fog Lights",
    "LED Bulbs",
    "Washer Fluid",
    "Rear Bumper",
    "Hood",
    "Fender",
    "Steering Wheel",
    "Dashboard Cover",
    "Car Alarm",
    "Socket Set",
    "Wrench Set",
    "Car Cover",
    "Phone Mount",
    "Motorcycle Chain",
    "Motorcycle Brakes",
    "Alloy Wheels",
    "Steel Wheels",
    "Wheel Nuts",
    "Distributor Cap",
    "Oil Change Kit",
    "Air Filter Replacement",
    "Wiper Blades"
  ],
  "pharmacy": [
    "Health",
    "Personal Care",
    "Beauty",
    "Hair Care",
    "Skin Care",
    "Nails",
    "Makeup",
    "Shampoos",
    "Conditioners",
    "Hair Products",
    "Baby Products",
    "Dairy",
    "Household",
    "Cleaning",
    "Supermarket"
  ],
  "latin": [
    "Meals",
    "Tacos",
    "Burritos",
    "Quesadillas",
    "Nachos",
    "Enchiladas",
    "Fajitas",
    "Rotisserie Chicken",
    "Paella",
    "Empanadas",
    "Arepas",
    "Pupusas",
    "Arroz con Pollo",
    "Ropa Vieja",
    "Lechon Asado",
    "Yuca Fries",
    "Plantains",
    "Maduros",
    "Tostones",
    "Mofongo",
    "Sancocho",
    "Chicharron",
    "Pernil",
    "Bandeja Paisa",
    "Lomo Saltado",
    "Pollo a la Brasa",
    "Rice Meals",
    "Sides",
    "Drinks",
    "Desserts",
    "Appetizers",
    "Soups",
    "Salads",
    "Burgers",
    "Chicken",
    "Fish",
    "Seafood",
    "Grilled Items",
    "Steaks",
    "Vegetarian"
  ],
  "mexican": [
    "Meals",
    "Tacos",
    "Burritos",
    "Quesadillas",
    "Nachos",
    "Enchiladas",
    "Fajitas",
    "Guacamole",
    "Salsa",
    "Tortillas",
    "Mexican Rice",
    "Refried Beans",
    "Tamales",
    "Churros",
    "Margaritas",
    "Mexican Coke",
    "Horchata",
    "Mole",
    "Ceviche",
    "Carnitas",
    "Carne Asada",
    "Pollo Asado",
    "Pozole",
    "Menudo",
    "Tortas",
    "Tostadas",
    "Elote",
    "Esquites",
    "Sides",
    "Drinks",
    "Desserts",
    "Appetizers",
    "Soups",
    "Salads"
  ],
  "sushi": [
    "Sushi & Specialty Rolls",
    "Bento & Sushi Platters",
    "Rice Dishes",
    "Noodles",
    "Soups",
    "Salads",
    "Appetizers",
    "Starters",
    "Drinks",
    "Seafood",
    "Grilled Fish",
    "Vegetarian",
    "Gluten-Free",
    "Sauces",
    "Cocktails"
  ],
  "steakHouse": [
    "Steaks",
    "Appetizers",
    "Main Course",
    "Seafood",
    "Grilled Fish",
    "Lobster",
    "Ribs",
    "Sides",
    "Drinks",
    "Desserts",
    "Cocktails",
    "Salads",
    "Soups"
  ],
  "localRestaurant": [
    "Meals",
    "Burgers",
    "Chicken",
    "Fish",
    "Seafood",
    "Sides",
    "Drinks",
    "Desserts",
    "Breakfast",
    "Fries",
    "Wraps",
    "Salads",
    "Platters",
    "Soups",
    "Vegetarian",
    "Chicken Burger",
    "Beef Burger",
    "Pork Burger",
    "Fish Burger",
    "Veggie Burger",
    "Fried Chicken",
    "Curry Chicken",
    "Oxtail"
  ]
};

// CATEGORIES_BY_TYPE is keyed by the iOS enum case name; Firestore and the
// UI work in rawValue display strings — map one to the other.
const TYPE_TO_KEY = {
  "Fast Food": "fastFood",
  "Bar & Grill": "barAndGrill",
  "Pizza": "pizza",
  "KFC": "kfc",
  "BBQ Grill": "bbqGrill",
  "Seafood Restaurant": "seafood",
  "Cafe": "cafe",
  "Beauty Supply": "beauty",
  "Retail Store": "store",
  "Farmer": "farmer",
  "Supermarket": "supermarket",
  "Fish/Meat Market": "fishAndMeat",
  "Asian": "asian",
  "Indian": "indian",
  "Bakery": "bakery",
  "Juice Stand": "juiceStand",
  "Craft & Souvenirs": "craft",
  "Liquor Store & Smoke Shop": "liquorStoreSmokeShop",
  "Roti/Patty": "rotiShop",
  "Perfume Store": "perfumeStore",
  "Jewelry Store": "jewelryStore",
  "Electronics Store": "electronicsStore",
  "Home Goods": "homeGoods",
  "Water Supply": "waterSupply",
  "Vegetarian": "vegetarian",
  "Snack Boxes": "snackBoxes",
  "Car Parts": "carParts",
  "Pharmacy": "pharmacy",
  "Latin": "latin",
  "Mexican": "mexican",
  "Sushi": "sushi",
  "Steak House": "steakHouse",
  "Local Restaurant": "localRestaurant",
};

// iOS MenuCategory.defaultCategories(for:) — display strings.
// Falls back to the fastFood list when the type is unknown, like the iOS default.
export function defaultCategories(restaurantType) {
  const key = TYPE_TO_KEY[restaurantType] || restaurantType;
  return CATEGORIES_BY_TYPE[key] || CATEGORIES_BY_TYPE.fastFood;
}
